<template>
  <div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="
        chk_relation_type_editable('/master/list') ? fromParentBtn : ''
      "
      :btnClass="'btn-primary'"
      :btnToLink="'/license_event_cd/add'"
      :routerSw="true"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>
    <div
      class="w100"
      v-if="
        typeof license_event_cd_list === 'object' &&
        Object.keys(license_event_cd_list).length > 0
      "
    >
      <table class="table">
        <thead>
          <tr>
            <th style="width: 10%">コード</th>
            <th style="width: 30%">名称</th>
            <th style="width: 10%">略称</th>
            <th style="width: 10%">ソートNo</th>
            <th colspan="2" style="width: 15%">action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="list in license_event_cd_list" :key="list.id">
            <td>{{ list.license_event_cd }}</td>
            <td>{{ list.label }}</td>
            <td>{{ list.short_label }}</td>
            <td>{{ list.sort }}</td>
            <td>
              <!-- <bs-button :btnClass="'btn-light btn-sm btn-outline-secondary'" @to_click_event="handleClick(list.id)">詳細</bs-button> -->
              <router-link
                :to="'/license_event_cd/' + list.id"
                class="btn btn-light btn-outline-secondary btn-sm"
                >詳細</router-link
              >
            </td>
            <td>
              <bs-button
                v-if="chk_relation_type_editable('/master/list')"
                :btnClass="'btn-danger btn-sm'"
                @to_click_event="delData(list.id)"
                >削除</bs-button
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <p class="alert alert-warning">NO DATA</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
// import '../../assets/bootstrap/css/sc.css';
// import Common from '../common/common'
import BsButton from '../../atoms/BsButton.vue'
import config from '../../../const'

export default {
  name: 'LicenseEventCdListView',
  data: function () {
    return {
      alertMessage: '',
      alertClass: 'alert-info',
      fromParentTitle: '種目コードマスタ一覧',
      fromParentBtn: 'データ登録',
      license_event_cd_obj: []
    }
  },
  components: {
    BsPageTitle,
    BsButton,
    BsMsgAlert
  },
  computed: {
    ...mapState({}),
    license_event_cd_list: function () {
      const lists = [...this.license_event_cd_obj]
      return lists.sort((a, b) => {
        if (parseInt(a.sort) < parseInt(b.sort)) {
          return -1
        } else {
          return 1
        }
      })
    }
  },

  async created() {
    await this.loadLicenseEventCdList()
  },
  mounted: function () {
    // console.log(this.$route.path);
    // console.log('strage', this.$store.state.article, this.lists);
    // this.fromParentTitle = '商品詳細';
    this.alertMessage = '種目コードマスタです。'
  },

  methods: {
    delData(target) {
      if (confirm('削除しますか？')) {
        const data = this.license_event_cd_obj.find(event => {
          return event.id == target
        })
        // console.log('ret ticket data' ,ticket);
        data['stat'] = 9
        return this.$store
          .dispatch('updateBasic', { data: data, target: 'license_event_cd' })
          .then(() => {
            this.alertMessage = '削除しました'
            this.alertClass = 'alert-success'
          })
          .catch(err => {
            // Promise.reject(err)
            console.log(err)
            this.alertMessage = '削除できませんでした'
            this.alertClass = 'alert-danger'
          })
          .finally(() => {
            this.loadLicenseEventCdList()
          })
      }
    },
    async loadLicenseEventCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/license_event_cd/lists',
        params
      )
        .then(async response => {
          console.log('loadLicenseEventCdList response', response)
          this.license_event_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_event_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    handleClick(target) {
      this.$router.push({ path: '/license_event_cd/' + target + '/' })
    }
  }
}
</script>
